<div>
  <img class="table-thumbnail" [src]="record.thumbnail" />
  <div>
    <span>{{ record.name }}</span>
    <span>{{ record.sku }}</span>
  </div>
</div>
